export default function Spinner() {
    return (<svg className="bwjm0vhl sx61ek5s" width="32" height="32" viewBox="0 0 43 43" role="status">
        <circle className="bvgz89zs a5uym4to pgr" cx="21.5" cy="21.5" r="20" fill="none" strokeWidth="3"
            style={{ strokeDasharray: "126, 126", strokeDashoffset: "0" }}></circle>
        <circle className="bvgz89zs gibn6ev6 pg" cx="21.5" cy="21.5" r="20" fill="none" strokeWidth="3"
            style={{ strokeDasharray: "126, 126", strokeDashoffset: "75.6" }}></circle>
    </svg>)
}
